import { EntityId, PaginationRequest } from '../common';

export interface IJobsiteSalesAreasRequest extends PaginationRequest {
  jobsiteSalesAreaIds?: EntityId[];
  legalEntityIds?: EntityId[];
  shipmentLocationId?: EntityId | number;
  productLineId?: number | string;
  orderBy?: string;
}
